/**
 * Canonical Instagram post URL and its shortcode. Accepts /p/ and /reel/
 * links, with or without a username segment, `www.`, query or fragment.
 * The media id is never derived from it. public.link_instagram applies the
 * same rule in the database.
 */
export function parseInstagramUrl(input: string): { url: string; shortcode: string } {
  let url: URL;
  try {
    url = new URL(input.trim());
  } catch {
    throw new Error(`Not a URL: "${input}"`);
  }
  if (url.protocol !== "https:" || !/^(www\.)?instagram\.com$/.test(url.hostname)) {
    throw new Error(`Not an Instagram post URL: "${input}" (expected https://www.instagram.com/p/<code>/)`);
  }
  const match = url.pathname.match(/^\/(?:[A-Za-z0-9._]+\/)?(p|reel)\/([A-Za-z0-9_-]+)\/?$/);
  if (!match) throw new Error(`Not an Instagram post URL: "${input}" (expected https://www.instagram.com/p/<code>/)`);
  return { url: `https://www.instagram.com/${match[1]}/${match[2]}/`, shortcode: match[2]! };
}
